module.exports = __webpack_public_path__ + "7a83887cc8316a595d5ac7d4f8517fd5.pdf";